// @ts-nocheck

import classNames from 'classnames';
import debugLib from 'debug';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';
// TODO, dash_api should move to common
import dash_api from '../../../main/support/dash_api';

import Button from './Button';
import Input from './Input';

import { TIME_TO_DISPLAY_MESSAGE } from '../../support/utils';

const debug = debugLib('SendEmail');

function getStatusMsg(status) {
  const MESSAGES = {
    loading: '...sending',
    error: 'An error occurred',
    success: (
      <span>
        <i className="material-icons h_mend-5 h_fz-body1">done</i> Email sent!
      </span>
    ),
  };

  return MESSAGES[status];
}

class SendEmail extends React.PureComponent {
  static propTypes = {
    /**
     * Template name stored in server
     * TODO: template name is tightly coupled to what's available in the backend
     * Should allow for using custom template
     */
    template: PropTypes.string.isRequired,

    /**
     * data-testid attribute will be inserted into rendered HTML
     */
    testid: PropTypes.string.isRequired,

    /**
     * Current active app id
     */
    app_id: PropTypes.string,
    buttonClassName: PropTypes.string,
    customInputComponent: PropTypes.element,
    disabled: PropTypes.bool,

    /**
     * List of recipients to send the email
     */
    recipients: PropTypes.string,

    /**
     * List of recipients to be in cc
     */
    cc: PropTypes.arrayOf(PropTypes.string),

    /**
     * Class name for the outermost container of the component
     */
    className: PropTypes.string,

    /**
     * Class name for input component
     */
    inputClassName: PropTypes.string,

    /**
     * Text shown on the send button
     */
    placeholder: PropTypes.string,
    templateData: PropTypes.object,

    /**
     * Subject for the email to send
     * TODO: Make this required field once custom
     * template ability has been introduced
     * @default Will be used from the template
     */
    subject: PropTypes.string,
  };

  static defaultProps = {
    placeholder: 'name@email.com',
    templateData: {},
    disabled: false,
    className: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      recipients: props.recipients || null,
      status: null,
    };
  }

  _updateEmail = (e) => {
    this.setState({
      recipients: e.value,
      status: null,
    });
  };

  _sendEmail = () => {
    const { recipients } = this.state;
    const { app_id, subject, template, templateData, cc } = this.props;

    this.setState({ status: 'loading' });
    dash_api
      .post('/v1/send-email', {
        email: recipients,
        template,
        subject,
        data: R.merge(templateData, { app_id }),
        cc,
      })
      // biome-ignore lint/correctness/noUnusedVariables: ignored using `--suppress`
      .then((res) => {
        debug('Email sent successfully');
        this.setState({ status: 'success' });

        setTimeout(() => {
          this.setState({ status: null });
        }, TIME_TO_DISPLAY_MESSAGE);
      })
      .catch((err) => {
        debug('Email failed: ', err);
        this.setState({ status: 'error' });
      });
  };

  render() {
    const { disabled, placeholder, testid, customInputComponent, className, inputClassName, buttonClassName } = this.props;

    const { recipients, status } = this.state;

    return (
      <div data-testid={testid} className={`h_w-100 ${className}`}>
        <Input
          className={classNames('input-combo', inputClassName)}
          value={recipients}
          disabled={disabled}
          onChange={this._updateEmail}
          type="email"
          placeholder={placeholder}
          testid={`${testid}-send-email-input`}
          customChildComponent={customInputComponent}
          statusType={status}
          footnote={getStatusMsg(status)}
        />
        <Button
          onClick={this._sendEmail}
          disabled={disabled || status === 'error'}
          className={classNames('input-combo-btn input-combo-btn--no-title', buttonClassName)}
          testid={`${testid}-send-email-btn`}
        >
          Send
        </Button>
      </div>
    );
  }
}

export default SendEmail;
